module.exports = __webpack_public_path__ + "e1bfd2d3d3a5ff598c4d88f00ed8717b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/trees/branch-gold.png
// module id = 3480
// module chunks = 0